import { themeObj as CantileverTheme } from 'styles/cantileverTheme'
import { updateColorOpacity } from 'utils/colorHelpers'

export enum ComponentHealthCondition {
  Excellent = 'Excellent',
  Fair = 'Fair',
  Bad = 'Bad',
  VeryPoor = 'Very Poor',
}

export const HealthConditionColors: Record<ComponentHealthCondition, string> = {
  [ComponentHealthCondition.Excellent]: CantileverTheme.colors.success['450'],
  [ComponentHealthCondition.Fair]: CantileverTheme.colors.warning['400_base'],
  [ComponentHealthCondition.Bad]: CantileverTheme.colors.alert['300'],
  [ComponentHealthCondition.VeryPoor]: CantileverTheme.colors.alert['700'],
}
// TODO: Abstract this out to an entry to make it easily configurable
export const RLHealthConditionUpperBoundEnum = {
  VeryPoor: 3,
  Bad: 5,
  Fair: 10,
}

export const RiskScoreConditionBoundsEnum = {
  VeryPoor: 50,
  Bad: 66,
  Fair: 82,
}

export const getComponentHealthCondition = (
  remainingLife: number
): ComponentHealthCondition => {
  if (remainingLife > RLHealthConditionUpperBoundEnum.Fair) {
    return ComponentHealthCondition.Excellent
  } else if (remainingLife > RLHealthConditionUpperBoundEnum.Bad) {
    return ComponentHealthCondition.Fair
  } else if (remainingLife > RLHealthConditionUpperBoundEnum.VeryPoor) {
    return ComponentHealthCondition.Bad
  } else {
    return ComponentHealthCondition.VeryPoor
  }
}

export const getRiskScoreHealthCondition = (
  riskScore: number
): ComponentHealthCondition => {
  if (riskScore > RiskScoreConditionBoundsEnum.Fair) {
    return ComponentHealthCondition.Excellent
  } else if (riskScore > RiskScoreConditionBoundsEnum.Bad) {
    return ComponentHealthCondition.Fair
  } else if (riskScore > RiskScoreConditionBoundsEnum.VeryPoor) {
    return ComponentHealthCondition.Bad
  } else {
    return ComponentHealthCondition.VeryPoor
  }
}

export const getRLTagColor = (rl: number) => {
  const condition = getComponentHealthCondition(rl)
  return updateColorOpacity(HealthConditionColors[condition], 0.4)
}
